import Vue from 'vue'
import permission from './permission'

Vue.mixin(permission)



// WEBPACK FOOTER //
// ./src/mixin/index.js